import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import RewardProductInvoice from "../components/RewardProductInvoice";

const InvoicePage = () => {
    return (
        <>
            {/* MasterLayout */}
            <MasterLayout>
                {/* Breadcrumb */}
                <Breadcrumb title='Invoice' />

                <RewardProductInvoice />

            </MasterLayout>
        </>
    );
};

export default InvoicePage;
